import { BranchDetailsAlertWithBranchNameOutput } from './branch-details-alert-with-branch-name-output.model';


export class AlertGroupSelectCompanyBranchByIdOutputData implements IAlertGroupSelectCompanyBranchByIdOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    alert_group_branch_details!: BranchDetailsAlertWithBranchNameOutput[];

    constructor(data?: IAlertGroupSelectCompanyBranchByIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_group_id = _data["alert_group_id"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            if (Array.isArray(_data["alert_group_branch_details"])) {
                this.alert_group_branch_details = [] as any;
                for (let item of _data["alert_group_branch_details"])
                    this.alert_group_branch_details!.push(BranchDetailsAlertWithBranchNameOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertGroupSelectCompanyBranchByIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupSelectCompanyBranchByIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_group_id"] = this.alert_group_id;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        if (Array.isArray(this.alert_group_branch_details)) {
            data["alert_group_branch_details"] = [];
            for (let item of this.alert_group_branch_details)
                data["alert_group_branch_details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAlertGroupSelectCompanyBranchByIdOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    alert_group_branch_details: BranchDetailsAlertWithBranchNameOutput[];
}

